import CallLogForm from '@/pages/Business/Agent/CallLogs/components/CallLogForm';
import Signals from 'pages/Business/Agent/Signals';
import { Route } from 'react-router-dom';
import { home } from 'routes/config';

export const signalsRoutes = (
  <Route path={home.signals} element={<Signals />}>
    <Route path=':id' element={<CallLogForm />} />
  </Route>
);
